import Select from 'components/core/Select'
import { SERVICE_TYPE_OPTIONS } from 'constants/order.constants'
import { ServiceType } from 'types/order.types'

type ServiceTypeSelectProps = {
    isRequiredLabel?: boolean
    value?: ServiceType
    label?: string
    error?: string
    menuPlacement?: 'auto' | 'bottom' | 'top'
    onChange: (status: ServiceType) => void
}

export const ServiceTypeSelect = ({
    isRequiredLabel,
    value,
    error,
    label,
    menuPlacement,
    onChange,
}: ServiceTypeSelectProps) => {
    const _onChange = (value: string) => {
        onChange(value as ServiceType)
    }

    return (
        <Select
            isRequiredLabel={isRequiredLabel}
            value={value}
            error={error}
            label={label}
            menuPlacement={menuPlacement}
            options={SERVICE_TYPE_OPTIONS}
            onSelectedOptionChanged={_onChange}
        />
    )
}
